type GPUInfo = {
	vendor: string
	renderer: string
	blacklisted: boolean
	supportedExtensions: string[] | null
}

let cachedGPUDebugInfo: GPUInfo | null = null

// Exposed for tests that stub `document.createElement` — production code
// should not need to reset the cache.
export const __resetGPUDebugInfoCacheForTests = () => {
	cachedGPUDebugInfo = null
}

export function getGPUDebugInfo() {
	if (cachedGPUDebugInfo) {
		return cachedGPUDebugInfo
	}

	const info: GPUInfo = {
		vendor: "unknown",
		renderer: "unknown",
		blacklisted: false,
		supportedExtensions: [],
	}

	const canvas = document.createElement("canvas")
	const gl = (canvas.getContext("webgl", {
		powerPreference: "high-performance",
	}) ||
		canvas.getContext("experimental-webgl", {
			powerPreference: "high-performance",
		})) as WebGLRenderingContext | null

	if (!gl) {
		cachedGPUDebugInfo = info
		return info
	}

	info.supportedExtensions = gl.getSupportedExtensions()

	if (!info.supportedExtensions?.includes("OES_texture_float")) {
		info.blacklisted = true
	}

	const debugInfo = gl.getExtension("WEBGL_debug_renderer_info")

	if (debugInfo) {
		info.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL)
		info.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
	}

	cachedGPUDebugInfo = info
	return info
}

export { getGPUTier } from "detect-gpu"
